import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Card, Row, Col, Button } from 'react-bootstrap';
import { objectGiaiDoanDaoTao, giaiDoanDaoTaoValue } from '@app/utils/define';

import DuyetHoiDongDaoDuc from '../hoiDongDaoDuc/DuyetHoiDongDaoDuc';
import SoLieuNghienCuuTab from '../soLieuNghienCuu/SoLieuNghienCuuTab';
import DuyetHocPhanBoSung from '../hocPhanBoSung/DuyetHocPhanBoSung';
import DuyetHocPhanTienSi from '../hocPhanTienSi/DuyetHocPhanTienSi';
import DuyetChuyenDeTienSi from '../chuyenDeTienSi/DuyetChuyenDeTienSi';
import DuyetTieuLuanTongQuan from '../tieuLuanTongQuan/DuyetTieuLuanTongQuan';
import DuyetBaoVeCoSo from '../baoVeCoSo/DuyetBaoVeCoSo';
import DuyetPhanBienDocLap from '../phanBienDocLap/DuyetPhanBienDocLap';
import DuyetBaoVeCapVien from '../baoVeCapVien/DuyetBaoVeCapVien';

const QuanLyGiaiDoanDaoTaoNCS = () => {
    const history = useHistory();
    const { id } = useParams();
    const [activeTab, setActiveTab] = useState(giaiDoanDaoTaoValue.hoiDongDaoDuc);

    const renderTabContent = () => {
        switch (activeTab) {
            case giaiDoanDaoTaoValue.hoiDongDaoDuc:
                return <DuyetHoiDongDaoDuc hoSoId={id} />;
            case giaiDoanDaoTaoValue.soLieuNghienCuu:
                return <SoLieuNghienCuuTab hoSoId={id} isAdmin={true} />;
            case giaiDoanDaoTaoValue.hocPhanBoSung:
                return <DuyetHocPhanBoSung hoSoId={id} />;
            case giaiDoanDaoTaoValue.hocPhanTienSi:
                return <DuyetHocPhanTienSi hoSoId={id} />;
            case giaiDoanDaoTaoValue.chuyenDeTienSi:
                return <DuyetChuyenDeTienSi hoSoId={id} />;
            case giaiDoanDaoTaoValue.tieuLuanTongQuan:
                return <DuyetTieuLuanTongQuan hoSoId={id} />;
            case giaiDoanDaoTaoValue.baoVeCapCoSo:
                return <DuyetBaoVeCoSo hoSoId={id} />;
            case giaiDoanDaoTaoValue.phanBienDocLap:
                return <DuyetPhanBienDocLap hoSoId={id} />;
            case giaiDoanDaoTaoValue.baoVeCapVien:
                return <DuyetBaoVeCapVien hoSoId={id} />;
            default:
                return (
                    <div className="text-center p-5">
                        <h5>Tính năng đang được phát triển...</h5>
                    </div>
                );
        }
    };

    return (
        <div className="container-fluid">
            <Card className="mb-3 shadow-sm border-0" style={{ backgroundColor: '#f0f2f5' }}>
                <Card.Body className="p-3">
                    <Row className="mx-n1 mb-n2">
                        {objectGiaiDoanDaoTao.map((stage) => (
                            <Col md={4} key={stage.value} className="px-1 mb-2">
                                <div 
                                    className={`h-100 w-100 d-flex align-items-center justify-content-center text-center py-1 px-2 rounded btn ${activeTab === stage.value ? 'btn-primary text-white shadow-sm' : 'btn-light text-dark border'}`}
                                    onClick={() => setActiveTab(stage.value)}
                                    style={{ cursor: 'pointer', minHeight: '32px', transition: 'all 0.2s ease' }}
                                >
                                    <span className="font-weight-bold" style={{ fontSize: '1rem', lineHeight: '1.2' }}>{stage.label}</span>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Card.Body>
            </Card>

            <div style={{ minHeight: 'calc(100vh - 300px)' }}>
                {renderTabContent()}
            </div>
        </div>
    );
};

export default QuanLyGiaiDoanDaoTaoNCS;

